import { takeLatest, call, put } from 'redux-saga/effects';
import membershipFormsActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: {
    LOAD_FREEZE_DROPDOWN_DATA_REQUEST,
    LOAD_CANCEL_DROPDOWN_DATA_REQUEST,
    SUBMIT_FREEZE_REQUEST,
    SUBMIT_CANCEL_REQUEST,
    LOAD_CANCEL_IFRAME_URL_REQUEST,
    LOAD_FREEZE_IFRAME_URL_REQUEST,
    LOAD_FORMS_DETAILS_REQUEST,
  },
  Creators: {
    loadFreezeDropdownDataSuccess,
    loadFreezeDropdownDataFailure,
    loadCancelDropdownDataSuccess,
    loadCancelDropdownDataFailure,
    submitFreezeFailure,
    submitFreezeSuccess,
    submitCancelFailure,
    submitCancelSuccess,
    loadCancelIframeUrlSuccess,
    loadCancelIframeUrlFailure,
    loadFreezeIframeUrlSuccess,
    loadFreezeIframeUrlFailure,
    loadFormsDetailsSuccess,
    loadFormsDetailsFailure,
  },
} = membershipFormsActions;

const {
  Creators: { setError },
} = errorActions;

function* loadFreezeDropdownData() {
  try {
    const { data } = yield call(dxApi.get, `/api/hsforms/get-hs-freeze-formdata`);
    if (!data.success) {
      yield put(loadFreezeDropdownDataFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadFreezeDropdownDataSuccess(data.data));
    }
  } catch (error) {
    console.log('Error in getting freeze dropdown', error);
    yield put(loadFreezeDropdownDataFailure(error));
  }
}

function* loadCancelDropdownData() {
  try {
    const { data } = yield call(dxApi.get, `/api/hsforms/get-hs-cancel-formdata`);
    if (!data.success) {
      yield put(loadCancelDropdownDataFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadCancelDropdownDataSuccess(data.data));
    }
  } catch (error) {
    console.log('Error in getting cancel dropdown', error);
    yield put(loadCancelDropdownDataFailure(error));
  }
}

function* submitFreeze({ payload }) {
  try {
    const { data } = yield call(dxApi.post, `/api/hsforms/hs-freeze`, payload);
    if (!data.success) {
      yield put(submitFreezeFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(submitFreezeSuccess(data));
    }
  } catch (error) {
    console.log('error in submit freeze', error);
    yield put(submitFreezeFailure(error));
  }
}

function* submitCancel({ payload }) {
  try {
    const { data } = yield call(dxApi.post, `/api/hsforms/hs-cancel`, payload);
    if (!data.success) {
      yield put(submitCancelFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(submitCancelSuccess(data));
    }
  } catch (error) {
    console.log('error in submit freeze', error);
    yield put(submitCancelFailure(error));
  }
}

function* loadCancelIframeUrl({ caId }) {
  try {
    const { data } = yield call(
      dxApi.post,
      `/click2save/dx/initiate-process?caid=${caId}`
    );
    if (data) {
      yield put(loadCancelIframeUrlSuccess(data));
    }
  } catch (error) {
    console.log('error in loading cancel iframe url', error);
    yield put(loadCancelIframeUrlFailure(error));
  }
}

function* loadFreezeIframeUrl({ caId }) {
  try {
    const { data } = yield call(
      dxApi.post,
      `/click2save/dx/initiate-freeze-process?caid=${caId}`
    );
    if (data) {
      yield put(loadFreezeIframeUrlSuccess(data));
    }
  } catch (error) {
    console.log('error in loading freeze iframe url', error);
    yield put(loadFreezeIframeUrlFailure(error));
  }
}

function* loadFormsDetails({ caId }) {
  try {
    const { data } = yield call(
      dxApi.get,
      `/app/account/manage-membership-v2?caid=${caId}`
    );
    if (!data.success) {
      yield put(loadFormsDetailsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadFormsDetailsSuccess(data.data));
    }
  } catch (error) {
    console.log('error in loading cancel iframe url', error);
    yield put(loadFormsDetailsFailure(error));
  }
}

export function* membershipFormsSaga() {
  yield takeLatest(LOAD_FREEZE_DROPDOWN_DATA_REQUEST, loadFreezeDropdownData);
  yield takeLatest(LOAD_CANCEL_DROPDOWN_DATA_REQUEST, loadCancelDropdownData);
  yield takeLatest(SUBMIT_FREEZE_REQUEST, submitFreeze);
  yield takeLatest(SUBMIT_CANCEL_REQUEST, submitCancel);
  yield takeLatest(LOAD_CANCEL_IFRAME_URL_REQUEST, loadCancelIframeUrl);
  yield takeLatest(LOAD_FREEZE_IFRAME_URL_REQUEST, loadFreezeIframeUrl);
  yield takeLatest(LOAD_FORMS_DETAILS_REQUEST, loadFormsDetails);
}
